import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../../StateContext/Application";
import {
  Email32,
  Location32,
  PhoneNumber32,
} from "../../../../../public/LoginImages/importimages";


const VendorList = () => {
  const context = useContext(AdminContext);
  const { GetVendors } = context;
  const [vendor, setVendor] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  //const billsPerPage = 3;
  const [searchTerm, setSearchTerm] = useState("");

  const recordsPerPage = 10;
  const totalPages = Math.ceil(filteredBills.length / recordsPerPage);
  const indexOfLastBill = currentPage * recordsPerPage;
  const indexOfFirstBill = indexOfLastBill - recordsPerPage;
  const currentBills = filteredBills.slice(indexOfFirstBill, indexOfLastBill);

  const getVendors = async () => {
    let data = await GetVendors();
    setVendor(data);
    setFilteredBills(data);
  };
  useEffect(() => {
    getVendors();
  }, []);
  let vendorList = [];
  if (vendor.length > 0) {
    vendorList = vendor;
  }
  useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    const filtered = vendor.filter((bill) =>
      Object.values(bill).some((val) =>
        (val || "").toString().toLowerCase().includes(lowerSearchTerm),
      ),
    );
    setFilteredBills(filtered);
    setCurrentPage(1); // Reset to page 1 on search
  }, [searchTerm, vendor]);
   const getPageNumbers = () => {
    const maxVisiblePages = 5;

    // Total pages 5
    if (totalPages <= maxVisiblePages) {
      return Array.from(
        { length: totalPages },
        (_, index) => index + 1
      );
    }

    // Page 1, 2, 3 par
    // 1 2 3 4 5 ... Last
    if (currentPage <= 3) {
      return [1, 2, 3, 4, 5, "...", totalPages];
    }

    // Last pages
    // ... 16 17 18 19 20
    if (currentPage >= totalPages - 2) {
      return [
        "...",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages
      ];
    }

    // Middle pages
    // ... 4 5 6 7 8 ... 20
    return [
      "...",
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
      "...",
      totalPages
    ];
  };
   return (
 
     //2/11
     <div
   style={{
     width: "100%",
     maxWidth: "1000px",
     margin: "14px auto 0",
     background: "#EEF2F7",
     border: "1px solid #dfe5ee",
     borderRadius: "10px",
     padding: "15px 20px 20px",
     boxSizing: "border-box",
   }}
 >
     <div
       style={{
         // marginLeft: "18.5rem",
         // transition: "margin-left 0.3s ease",
         // backgroundColor: "#efecff", // full width background
         // minHeight: "100vh",         // covers the full height
         // width: "100%",               // full width coverage
         // display: "flex",
         // justifyContent: "center",
         // alignItems: "center",
         // padding: "60px 50px",          // spacing from top
         // boxSizing: "border-box",
         // overflowY: "auto"
      
         width: "auto",
         //2/11
         // minHeight: "90vh",
         // minHeight: '100vh',
         transition: "margin-left 0.3s ease",
         overflowY: "auto",
         msOverflowStyle: "none", // IE & Edge
         scrollbarWidth: "none",
         fontFamily: "Inter, sans-serif",
       }}
     >
       <div
         style={{
           display: "flex",
           justifyContent: "space-between",
           alignItems: "center",
           marginBottom: "10px",
           padding: "0 20px",
           width: "100%",
         }}
       >
         {/* <div  > */}
         {/* ---- Left Side: Title ---- */}
         <h5
           style={{
             fontWeight: "bold",
             color: "black",
             display: "flex",
             alignItems: "center",
             //   margin: 0,
           }}
         >
           <img
             src={"/Vendor-Details-List-32.png"}
             alt="Project Icon"
             style={{ marginRight: "10px", width: 28, height: 28 }}
           />
           Vendor List
         </h5>
 
         {/* ---- Right Side: Search Box ---- */}
         <div
           style={{
             display: "flex",
             alignItems: "center",
             border: "1px solid #ccc",
              //2/11
             borderRadius: "5px",
             padding: "3px 10px",
             width: "250px",
             backgroundColor:"white"
           }}
         >
           <img
             src={"/Search-32.png"}
             alt="Search Icon"
             className="search-icon"
             style={{ width: 20, height: 20, marginRight: "8px" }}
           />
           <input
             type="text"
             className="search-input"
             placeholder="Search Vendor..."
             value={searchTerm}
             onChange={(e) => setSearchTerm(e.target.value)}
             style={{
               border: "none",
               outline: "none",
               background: "transparent",
               width: "100%",
               fontSize: "12px",
               
             }}
           />
         </div>
       </div>
 
       <div
         style={{
           display: "grid",
           justifyContent: "center",
           boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
           borderRadius: "20px",
           // width: "75vw",
           backgroundColor: "white",
           padding: "20px 25px",
           maxHeight: "85vh", // reduced height
           overflow: "auto",
           //    marginTop: "-200px"
         }}
       >
         {/* //28/10 */}
        <div
   style={{
     overflowX: "auto",
     width: "100%",
     border: "1px solid #d9e1f2",  
     borderRadius: "8px",           
     boxSizing: "border-box",
   }}
 >
   <table
     style={{
       backgroundColor: "white",
       width: "100%",
       minWidth: "70vw",
       borderCollapse: "separate",  
       borderSpacing: 0,            
 
     }}
   >
             <thead>
               {/* //28/10 */}
               <tr
                 style={{
                   backgroundColor: "#2D79DB",
                   color: "white",
                   // height: "2rem",
                   fontSize: "14px",
                   fontWeight: "400",
                   textAlign: "center",
                   whiteSpace: "nowrap",
                 }}
               >
                 <th style={{ padding: "10px" }}>Unique ID</th>
                 <th style={{ padding: "10px" }}>Company Name</th>
                 <th style={{ padding: "10px" }}>Email</th>
                 {/* <th style={{ padding: "10px" }}>Address</th> */}
                 <th style={{ padding: "10px" }}> City</th>
                 <th style={{ padding: "10px" }}> Phone Number</th>
                 <th style={{ padding: "10px" }}> Pincode</th>
                 <th style={{ padding: "10px" }}> GST NUMBER</th>
                 <th style={{ padding: "10px" }}> PAN NUMBER</th>
                 <th style={{ padding: "10px" }}> Account Number</th>
                 <th style={{ padding: "10px" }}> Bank Name</th>
                 <th style={{ padding: "10px" }}> IFSC CODE</th>
                 <th style={{ padding: "10px" }}> Branch Name</th>
                 {/*<th style={{ padding: "10px" }}> Account Holder Name</th> */}
               </tr>
             </thead>
             {/* 02-10  */}
              {currentBills.length === 0 ? (
   <tbody>
     <tr>
      <td
   colSpan="14"
   style={{
     padding: "30px",
     fontSize: "14px",
     color: "#666",
     textAlign: "center",
   }}
 >
   <div
     style={{
       position: "sticky",
       left: "50%",
       transform: "translateX(-50%)",
       width: "max-content",
       textAlign: "center",
     }}
   >
     No Data Available
   </div>
 </td>
     </tr>
   </tbody>
 )  : (
  
             currentBills.map((vendor, index) => {
               // const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
               return (
                 <tbody>
                   <tr
                     key={index}
                     style={{
                       fontSize: "13px",
                       fontWeight: "500",
                       textAlign: "center",
                     //2/11
                       backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#CEE4F1",
                     }}
                   >
                     {/* //2/11 */}
                     <td style={{ padding: "10px", color: "blue",textAlign:"center", border: "1px solid white", }}>{vendor.UniqueID}</td>
                     <td style={{ padding: "10px", border: "1px solid white", }}>
                       {vendor.Bidder_CompanyName}
                     </td>
                     <td style={{ padding: "10px", border: "1px solid white", }}>
                       <div
                         style={{
                           display: "flex",
                           justifyContent: "center",
                           gap: "5px",
                         }}
                       >
                         <img src={Email32} style={{ width: "13px" }} />{" "}
                         {vendor.Email}
                       </div>
                     </td>
                     {/* <td style={{ padding: "10px" }}>
                       <div
                         style={{
                           display: "flex",
                           justifyContent: "start",
                           gap: "5px",
                         }}
                       >
                         <img src={Location32} style={{ width: "13px" }} />{" "}
                         {vendor.Address}
                       </div>
                     </td> */}
                     <td style={{ padding: "10px", border: "1px solid white", }}>
                       <div
                         style={{
                           display: "flex",
                           justifyContent: "start",
                           gap: "5px",
                         }}
                       >
                         <img src={Location32} style={{ width: "13px" }} />{" "}
                         {vendor.City}
                       </div>
                     </td>
 
                     <td style={{border: "1px solid white",}}>
                       <div
                         style={{
                           display: "flex",
                           justifyContent: "center",
                           gap: "5px",
                         }}
                       >
                         <img src={PhoneNumber32} style={{ width: "13px" }} />{" "}
                         {vendor.Mobile_No}
                       </div>
                     </td>
                     {/* //28/10 */}
                     <td style={{ padding: "10px", border: "1px solid white", }}>{vendor.PinCode}</td>
                     <td style={{ padding: "10px", border: "1px solid white", }}>{vendor.GST_No}</td>
                     <td style={{ padding: "10px", border: "1px solid white", }}>{vendor.PAN_No}</td>
                     <td style={{ padding: "10px", border: "1px solid white", }}>{vendor.Account_Number}</td>
                     <td style={{ padding: "10px", border: "1px solid white", }}>{vendor.BANK_NAME}</td>
                     <td style={{ padding: "10px", border: "1px solid white", }}>{vendor.IFSC_CODE}</td>
                     <td style={{ padding: "10px", border: "1px solid white", }}>{vendor.BranchName}</td>
                     {/* <td style={{ padding: "10px" }}>
                       {vendor.Account_HolderName}
                     </td> */}
                   </tr>
                 </tbody>
                );
             })
 )}
 
           </table>
 
           {/* </div> */}
         </div>
 
         <div
           style={{
             width: "100%",
             display: "flex",
             alignItems: "center",
             justifyContent: "space-between",
             marginTop: "15px",
             padding: "10px 5px",
             boxSizing: "border-box",
           }}
         >
           {/* Showing Text */}
           <div>
             <p
               style={{
                 margin: 0,
                 fontSize: "13px",
                 color: "#333",
                 whiteSpace: "nowrap",
               }}
             >
               Showing {filteredBills?.length === 0 ? 0 : indexOfFirstBill + 1}{" "}
               to {Math.min(indexOfLastBill, filteredBills?.length || 0)} of{" "}
               {filteredBills?.length || 0} entries
             </p>
           </div>
 
           {/* Pagination Buttons */}
           <div
             style={{
               display: "flex",
               alignItems: "center",
               gap: "6px",
             }}
           >
             {/* Previous */}
             <button
               onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
               disabled={currentPage === 1}
               style={{
                 border: "none",
                 background: "transparent",
                 color: currentPage === 1 ? "#999" : "#2ea4e7",
                 cursor: currentPage === 1 ? "not-allowed" : "pointer",
                 fontSize: "13px",
                 padding: "0 4px",
                 opacity: currentPage === 1 ? 0.5 : 1,
               }}
             >
               ‹ Previous
             </button>
 
             {/* Page Numbers */}
             <div
               style={{
                 display: "flex",
                 alignItems: "center",
                 gap: "12px",
               }}
             >
               {getPageNumbers().map((pageNumber, index) =>
                 pageNumber === "..." ? (
                   <span
                     key={`dots-${index}`}
                     style={{
                       fontSize: "13px",
                       color: "#444",
                     }}
                   >
                     ...
                   </span>
                 ) : (
                   <button
                     key={pageNumber}
                     onClick={() => setCurrentPage(pageNumber)}
                     style={{
                       border: "none",
                       background: "transparent",
                       padding: 0,
                       color: currentPage === pageNumber ? "#2ea4e7" : "#444",
                       cursor: "pointer",
                       fontSize: "13px",
                       fontWeight: currentPage === pageNumber ? "600" : "400",
                       textDecoration:
                         currentPage === pageNumber ? "underline" : "none",
                     }}
                   >
                     {pageNumber}
                   </button>
                 ),
               )}
             </div>
 
             {/* Next */}
             <button
               onClick={() =>
                 setCurrentPage((prev) => Math.min(prev + 1, totalPages))
               }
               disabled={currentPage === totalPages || totalPages === 0}
               style={{
                 border: "none",
                 background: "transparent",
                 color:
                   currentPage === totalPages || totalPages === 0
                     ? "#999"
                     : "#2ea4e7",
                 cursor:
                   currentPage === totalPages || totalPages === 0
                     ? "not-allowed"
                     : "pointer",
                 fontSize: "13px",
                 padding: "0 4px",
                 opacity:
                   currentPage === totalPages || totalPages === 0 ? 0.5 : 1,
               }}
             >
               Next ›
             </button>
           </div>
         </div>
       </div>
     </div>
     </div>
   );
};
export default VendorList;
